(function () {
  var drawer = document.querySelector('[data-sply-cart]');
  if (!drawer) return;
  var itemsEl = drawer.querySelector('[data-sply-cart-items]');
  var lastItemsSig = itemsEl ? (itemsEl.getAttribute('data-cart-sig') || '') : '';
  function sizeImg(u){ if(!u) return u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=200'; }
  function prewarm(){
    fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var items = c.items || [];
        items.forEach(function (it) { if (it.image) { var im = new Image(); im.src = sizeImg(it.image); } });
        if (upsellEnabled && items.length) {
          var fid = items[0].product_id;
          if (!recCache[fid]) {
            fetch('/recommendations/products.json?product_id=' + fid + '&limit=10&intent=related', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
              .then(function (r) { return r.json(); })
              .then(function (d) { var m = mapRecs(d && d.products); recCache[fid] = m; warmImgs(m); })
              .catch(function () {});
          }
        }
      })
      .catch(function () {});
  }
  function warmImgs(arr) { (arr || []).forEach(function (p) { if (p && p.image) { var im = new Image(); im.src = sizeImg(p.image); } }); }
  function warmAll() { prewarm(); warmImgs(fallbackData); }
  if ('requestIdleCallback' in window) { requestIdleCallback(warmAll); } else { window.setTimeout(warmAll, 800); }
  var emptyEl = drawer.querySelector('[data-sply-cart-empty]');
  var footEl = drawer.querySelector('[data-sply-cart-foot]');
  var totalEl = drawer.querySelector('[data-sply-cart-total]');

  var barEnabled = drawer.getAttribute('data-bar-enabled') === 'true';
  var barThreshold = parseInt(drawer.getAttribute('data-bar-threshold'), 10) || 0;
  var barReward = drawer.getAttribute('data-bar-reward') || 'free shipping';
  var barEl = drawer.querySelector('[data-sply-bar]');
  var barMsg = drawer.querySelector('[data-sply-bar-msg]');
  var barFill = drawer.querySelector('[data-sply-bar-fill]');
  var upsellEnabled = drawer.getAttribute('data-upsell-enabled') === 'true';
  var upsellLimit = parseInt(drawer.getAttribute('data-upsell-limit'), 10) || 6;
  var upsellEl = drawer.querySelector('[data-sply-upsell]');
  var upsellTrack = drawer.querySelector('[data-sply-upsell-track]');
  var upsellToggle = drawer.querySelector('[data-sply-upsell-toggle]');
  var UPSELL_KEY = 'sply-upsell-collapsed';
  function applyUpsellCollapsed() {
    var collapsed = false; try { collapsed = localStorage.getItem(UPSELL_KEY) === '1'; } catch (e) {}
    if (upsellEl) upsellEl.classList.toggle('is-collapsed', collapsed);
    if (upsellToggle) upsellToggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
  }
  applyUpsellCollapsed();
  var fallbackData = (function () { var el = drawer.querySelector('[data-sply-upsell-fallback]'); if (!el) return []; try { return JSON.parse(el.textContent) || []; } catch (e) { return []; } })();
  var recCache = {};
  var upsellSig = '';

  var syncEl = drawer.querySelector('[data-sply-sync]');
  var pending = 0;
  function syncStart() { pending++; if (syncEl) syncEl.classList.add('is-active'); }
  function syncEnd() { pending = Math.max(0, pending - 1); if (!pending && syncEl) syncEl.classList.remove('is-active'); }
  var qtyTimers = {};

  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  function makeFmt(min) {
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency, minimumFractionDigits: min, maximumFractionDigits: 2 }); }
    catch (e) { return { format: function (v) { return '$' + (min ? v.toFixed(2) : String(v)); } }; }
  }
  var fmtWhole = makeFmt(0), fmtCents = makeFmt(2);
  function money(cents) { cents = cents || 0; return (cents % 100 === 0 ? fmtWhole : fmtCents).format(cents / 100); }
  function esc(t) { return (t == null ? '' : String(t)).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function setCount(n) {
    var els = document.querySelectorAll('[data-cart-count]');
    for (var i = 0; i < els.length; i++) { els[i].textContent = n; els[i].hidden = !n; }
  }
  var closeT = null;
  function openDrawer(expectItems) { if (closeT) { window.clearTimeout(closeT); closeT = null; } drawer.classList.remove('is-closing'); if (expectItems && emptyEl) { emptyEl.hidden = true; } drawer.hidden = false; document.documentElement.classList.add('sply-cart-open'); window.dispatchEvent(new CustomEvent('sply:overlayopen', { detail: 'cart' })); refresh();
    if (window.__splyWalletPatch) {
      window.__splyWalletPatch();
      requestAnimationFrame(function () { window.dispatchEvent(new Event('resize')); window.__splyWalletPatch(); });
      [120, 350, 700, 1200, 1800].forEach(function (d) { window.setTimeout(function () { window.dispatchEvent(new Event('resize')); window.__splyWalletPatch(); }, d); });
    }
  }
  window.addEventListener('sply:overlayopen', function (e) { if (e.detail !== 'cart' && !drawer.hidden) closeDrawer(); });
  function closeDrawer() { if (drawer.hidden || drawer.classList.contains('is-closing')) return; drawer.classList.add('is-closing'); document.documentElement.classList.remove('sply-cart-open'); closeT = window.setTimeout(function () { drawer.hidden = true; drawer.classList.remove('is-closing'); closeT = null; }, 520); }

  function render(cart) {
    setCount(cart.item_count);
    if (!cart.items || !cart.items.length) {
      if (lastItemsSig !== '') { itemsEl.innerHTML = ''; lastItemsSig = ''; }
      itemsEl.hidden = true; emptyEl.hidden = false; footEl.hidden = true;
      renderBar(cart); renderUpsell(cart);
      return;
    }
    itemsEl.hidden = false; emptyEl.hidden = true; footEl.hidden = false;
    var sig = cart.items.map(function (it) { return it.key + ':' + it.quantity; }).join(';');
    if (sig === lastItemsSig) { totalEl.textContent = money(cart.total_price); renderBar(cart); renderUpsell(cart); return; }
    lastItemsSig = sig;
    var html = '';
    cart.items.forEach(function (it) {
      var hasVar = it.variant_title && it.variant_title !== 'Default Title';
      html += '<li class="sply-citem sply-border" data-key="' + esc(it.key) + '">'
        + '<a class="sply-citem__media" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(sizeImg(it.image)) + '" alt="" width="120" height="120" loading="eager" decoding="async" fetchpriority="high">' : '') + '</a>'
        + '<span class="sply-citem__info">'
        + '<a class="sply-citem__name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>'
        + (hasVar ? '<span class="sply-citem__variant sply-muted">' + esc(it.variant_title) + '</span>' : '')
        + '<span class="sply-citem__price">' + money(it.final_line_price) + '</span>'
        + '</span>'
        + '<span class="sply-citem__qty">'
        + '<button type="button" class="sply-citem__step" data-sply-qty="' + esc(it.key) + '" data-delta="-1" aria-label="Decrease">−</button>'
        + '<span class="sply-citem__n">' + it.quantity + '</span>'
        + '<button type="button" class="sply-citem__step" data-sply-qty="' + esc(it.key) + '" data-delta="1" aria-label="Increase">+</button>'
        + '</span>'
        + '</li>';
    });
    itemsEl.innerHTML = html;
    totalEl.textContent = money(cart.total_price);
    renderBar(cart); renderUpsell(cart);
  }

  function renderBar(cart) {
    if (!barEnabled || !barEl || barThreshold <= 0) { if (barEl) barEl.hidden = true; return; }
    if (!cart.items || !cart.items.length) { barEl.hidden = true; return; }
    barEl.hidden = false;
    var total = cart.total_price;
    var pct = Math.max(0, Math.min(100, total / barThreshold * 100));
    if (barFill) barFill.style.width = pct + '%';
    if (total >= barThreshold) {
      barEl.classList.add('is-met');
      if (barMsg) barMsg.textContent = "You've unlocked " + barReward + ".";
    } else {
      barEl.classList.remove('is-met');
      if (barMsg) barMsg.innerHTML = "You're <strong class=\"sply-drawer__bar-amt\">" + money(barThreshold - total) + " away</strong> from " + barReward + ".";
    }
  }

  function mapRecs(arr) {
    return (arr || []).map(function (p) {
      var v = null, vs = p.variants || [];
      for (var i = 0; i < vs.length; i++) { if (vs[i].available) { v = vs[i]; break; } }
      if (!v && vs.length) v = vs[0];
      return { id: p.id, title: p.title, price: p.price, image: p.featured_image || (p.images && p.images[0]) || '', variant: v ? v.id : 0, available: !!(v && v.available), url: p.url || ('/products/' + (p.handle || '')), multi: vs.length > 1 };
    });
  }
  function paintUpsell(items) {
    if (!items.length) { upsellEl.hidden = true; upsellSig = ''; return; }
    upsellEl.hidden = false;
    var sig = items.map(function (p) { return p.variant; }).join(',');
    if (sig === upsellSig) return;   // already rendered these exact items -> don't rebuild (no image flash)
    upsellSig = sig;
    var html = '';
    items.forEach(function (p, i) {
      var media = p.image ? '<img src="' + esc(sizeImg(p.image)) + '" alt="" loading="eager" decoding="async">' : '';
      var cta = p.multi
        ? '<a class="sply-upsell__add" href="' + esc(p.url) + '">View</a>'
        : '<button type="button" class="sply-upsell__add" data-sply-upsell-add="' + esc(p.variant) + '" aria-label="Add ' + esc(p.title) + '"><span class="sply-upsell__add-label">Add</span></button>';
      html += '<div class="sply-upsell" style="animation-delay:' + (i * 55) + 'ms">'
        + '<a class="sply-upsell__media" href="' + esc(p.url) + '">' + media + '</a>'
        + '<a class="sply-upsell__name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>'
        + '<span class="sply-upsell__price">' + money(p.price) + '</span>'
        + cta
        + '</div>';
    });
    upsellTrack.innerHTML = html;
  }
  function renderUpsell(cart) {
    if (!upsellEnabled || !upsellEl) return;
    if (!cart.items || !cart.items.length) { upsellEl.hidden = true; return; }
    var cartIds = cart.items.map(function (it) { return it.product_id; });
    var firstId = cart.items[0].product_id;
    function done(recs) {
      var items = recs.filter(function (p) { return cartIds.indexOf(p.id) < 0 && p.variant && p.available; });
      if (!items.length) items = fallbackData.filter(function (p) { return cartIds.indexOf(p.id) < 0 && p.variant && p.available; });
      paintUpsell(items.slice(0, upsellLimit));
    }
    if (recCache[firstId]) { done(recCache[firstId]); return; }
    fetch('/recommendations/products.json?product_id=' + firstId + '&limit=10&intent=related', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) { var m = mapRecs(d && d.products); recCache[firstId] = m; warmImgs(m); done(m); })
      .catch(function () { recCache[firstId] = []; done([]); });
  }

  function refresh() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); }).then(render).catch(function () {});
  }
  function changeQty(key, qty) {
    syncStart();
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(render).catch(function () {}).then(syncEnd);
  }
  function stepQty(key, li, delta) {
    var nEl = li.querySelector('.sply-citem__n');
    var cur = nEl ? parseInt(nEl.textContent, 10) || 0 : 0;
    var next = Math.max(0, cur + delta);
    if (nEl) nEl.textContent = next;          // optimistic: number updates instantly
    li.classList.add('is-updating');          // dim price while it recalculates
    window.clearTimeout(qtyTimers[key]);
    qtyTimers[key] = window.setTimeout(function () { changeQty(key, next); }, 280);
  }
  function setH(root, sel, h) { var el = root && root.querySelector(sel); if (el) el.hidden = h; }
  function closeSizechart(modal) {
    if (!modal || modal.hidden || modal.classList.contains('is-closing')) return;
    modal.classList.add('is-closing');
    window.setTimeout(function () { modal.hidden = true; modal.classList.remove('is-closing'); }, 280);
  }
  var reduceMo = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function scrambleTo(el, target) {
    if (!el) return;
    target = (target == null ? '' : String(target));
    if (el._sIv) { window.clearInterval(el._sIv); el._sIv = null; }
    if (reduceMo) { el.textContent = target; return; }
    var glyphs = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    var n = target.length, ends = [];
    for (var i = 0; i < n; i++) {
      var c = target.charAt(i);
      ends.push((c === ' ' || c === '-' || c === '/' || c === '.') ? 0 : Math.round(i * 1.4) + 4 + Math.floor(Math.random() * 5));
    }
    var frame = 0;
    el._sIv = window.setInterval(function () {
      var out = '', done = 0;
      for (var j = 0; j < n; j++) {
        var ch = target.charAt(j);
        if (ends[j] === 0 || frame >= ends[j]) { out += ch; done++; }
        else out += glyphs.charAt(Math.floor(Math.random() * glyphs.length));
      }
      el.textContent = out;
      frame++;
      if (done === n) { window.clearInterval(el._sIv); el._sIv = null; el.textContent = target; }
    }, 28);
  }
  function expandBuy(pdpEl) {
    setH(pdpEl, '[data-sply-name]', true);
    setH(pdpEl, '[data-sply-buyhead]', false);
    setH(pdpEl, '[data-sply-buy]', true);
    setH(pdpEl, '[data-sply-sizes]', false);
    setH(pdpEl, '[data-sply-info-toggle]', false);
    if (pdpEl) { void pdpEl.offsetWidth; pdpEl.classList.add('is-buying'); }   // reflow committed -> transition spreads open
    var hlabel = pdpEl && pdpEl.querySelector('.sply-pdp__hlabel');
    if (hlabel) {
      if (!hlabel.getAttribute('data-label')) hlabel.setAttribute('data-label', hlabel.textContent);
      scrambleTo(hlabel, hlabel.getAttribute('data-label'));   // title -> SELECT SIZE (decode)
    }
  }
  function hardCollapse(pdpEl) {
    if (pdpEl) pdpEl.classList.remove('is-info');
    setH(pdpEl, '[data-sply-name]', false);
    setH(pdpEl, '[data-sply-buyhead]', true);
    setH(pdpEl, '[data-sply-buy]', false);
    setH(pdpEl, '[data-sply-price]', false);
    setH(pdpEl, '[data-sply-sizes]', true);
    setH(pdpEl, '[data-sply-info-toggle]', true);
    setH(pdpEl, '[data-sply-desc]', true);
  }
  function collapseBuy(pdpEl) {
    if (pdpEl && pdpEl.classList.contains('is-buying')) {
      var hlabel = pdpEl.querySelector('.sply-pdp__hlabel');
      var nameEl = pdpEl.querySelector('[data-sply-name]');
      var plus = pdpEl.querySelector('[data-sply-buy]');
      var title = nameEl ? nameEl.textContent : '';
      pdpEl.classList.remove('is-buying');             // ?/x + sizes converge on the + spot and fade out
      if (hlabel) scrambleTo(hlabel, title);           // SELECT SIZE -> product title (decode)
      window.setTimeout(function () {
        setH(pdpEl, '[data-sply-sizes]', true);         // sizes have faded; clear them
        setH(pdpEl, '[data-sply-buy]', false);          // bring the + back...
        if (plus) { try { plus.animate([{ opacity: 0, transform: 'scale(.85)' }, { opacity: 1, transform: 'none' }], { duration: 340, easing: 'cubic-bezier(.22,1,.36,1)' }); } catch (e) {} }
      }, 200);                                           // ...while the icons are still converging, so it feels merged (no blank gap)
      window.setTimeout(function () {
        setH(pdpEl, '[data-sply-name]', false);         // show the title heading (matches decoded text)
        setH(pdpEl, '[data-sply-buyhead]', true);
        setH(pdpEl, '[data-sply-info-toggle]', true);
        setH(pdpEl, '[data-sply-desc]', true);
        if (hlabel) hlabel.textContent = hlabel.getAttribute('data-label') || hlabel.textContent;   // reset for next open
      }, 470);
    } else { hardCollapse(pdpEl); }
  }
  function flipPlus(pdpEl, toX, firstRect) {
    var plus = pdpEl.querySelector('[data-sply-buy]');
    var bx = pdpEl.querySelector('[data-sply-buy-close]');   // hidden, only the corner target
    if (!plus) return;
    if (plus._flip) { plus._flip.cancel(); plus._flip = null; }   // never stack animations
    var opt = { duration: 460, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'forwards' };
    if (toX && bx) {
      var first = firstRect || plus.getBoundingClientRect();
      var tgt = bx.getBoundingClientRect();                  // X corner at its real grid spot
      var pr = pdpEl.getBoundingClientRect();
      plus.style.position = 'absolute';
      plus.style.margin = '0';
      plus.style.zIndex = '6';
      plus.style.transform = '';
      plus.style.left = (tgt.left + tgt.width / 2 - pr.left - first.width / 2) + 'px';
      plus.style.top = (tgt.top + tgt.height / 2 - pr.top - first.height / 2) + 'px';
      var now = plus.getBoundingClientRect();
      var dx = first.left - now.left, dy = first.top - now.top;
      plus._flip = plus.animate([
        { transform: 'translate(' + dx + 'px,' + dy + 'px) rotate(0deg)' },   // start at the + spot
        { transform: 'translate(0px,0px) rotate(45deg)' }                     // land on the corner as an X
      ], opt);
    } else {
      var firstE = plus.getBoundingClientRect();             // currently the X corner
      plus.style.position = ''; plus.style.margin = ''; plus.style.zIndex = '';
      plus.style.left = ''; plus.style.top = ''; plus.style.transform = '';   // back into the flow + spot
      var nowE = plus.getBoundingClientRect();
      var dxE = firstE.left - nowE.left, dyE = firstE.top - nowE.top;
      plus._flip = plus.animate([
        { transform: 'translate(' + dxE + 'px,' + dyE + 'px) rotate(45deg)' },
        { transform: 'translate(0px,0px) rotate(0deg)' }
      ], opt);
    }
  }
  function enterInfo(pdpEl) {
    if (!pdpEl) return;
    var simple = pdpEl.classList.contains('sply-pdp--simple');
    var plusE = pdpEl.querySelector('[data-sply-buy]');
    var soldout = simple && !plusE;                   // sold-out simple: no + to flip
    var hlabel = pdpEl.querySelector('.sply-pdp__hlabel');
    var flipFirst = null;
    if (simple && plusE) {                            // in-stock no-variant: the + travels up to the X corner
      flipFirst = plusE.getBoundingClientRect();
      setH(pdpEl, '[data-sply-name]', true);
      setH(pdpEl, '[data-sply-buyhead]', false);
    } else if (soldout) {                             // sold-out no-variant: bring up the heading + spread the X
      var nmIn = pdpEl.querySelector('[data-sply-name]');
      setH(pdpEl, '[data-sply-name]', true);
      setH(pdpEl, '[data-sply-soldout]', true);       // hide SOLD OUT while info is open
      setH(pdpEl, '[data-sply-buyhead]', false);
      if (hlabel && nmIn) hlabel.textContent = nmIn.textContent;   // start from the title so it decodes title -> INFORMATION
      void pdpEl.offsetWidth;
      pdpEl.classList.add('is-buying');               // X spreads in from the + spot
    }
    // don't display:none the size-chart icon (that drops it as a grid item and collapses the
    // 1fr/auto/1fr heading); CSS (.is-info [data-sply-sizechart]) hides it with visibility:hidden,
    // keeping its grid cell so INFORMATION stays centered and the X stays far-right.
    setH(pdpEl, '[data-sply-price]', true);          // hide price + sizes so the info scoots up
    setH(pdpEl, '[data-sply-sizes]', true);
    setH(pdpEl, '[data-sply-info-toggle]', true);
    setH(pdpEl, '[data-sply-desc]', false);
    pdpEl.classList.add('is-info');
    if (hlabel) scrambleTo(hlabel, 'Information');    // SELECT SIZE -> INFORMATION (decode)
    if (simple && plusE) flipPlus(pdpEl, true, flipFirst);   // slide + into the corner + rotate it into an X
    var dEl = pdpEl.querySelector('[data-sply-desc]');
    if (dEl) {
      dEl.scrollTop = 0; dEl.classList.remove('is-end');
      dEl.classList.toggle('is-scroll', dEl.scrollHeight > dEl.clientHeight + 2);
      if (!dEl._scrollBound) {
        dEl._scrollBound = true;
        dEl.addEventListener('scroll', function () { dEl.classList.toggle('is-end', dEl.scrollTop + dEl.clientHeight >= dEl.scrollHeight - 4); });
      }
    }
  }
  function exitInfo(pdpEl) {
    if (!pdpEl) return;
    var simple = pdpEl.classList.contains('sply-pdp--simple');
    var plusE = pdpEl.querySelector('[data-sply-buy]');
    var soldout = simple && !plusE;
    var hlabel = pdpEl.querySelector('.sply-pdp__hlabel');
    setH(pdpEl, '[data-sply-desc]', true);
    pdpEl.classList.remove('is-info');
    if (simple && plusE) {
      setH(pdpEl, '[data-sply-buyhead]', true);       // collapse heading
      setH(pdpEl, '[data-sply-name]', false);         // restore title
      setH(pdpEl, '[data-sply-price]', false);        // restore price
      setH(pdpEl, '[data-sply-info-toggle]', false);  // restore INFORMATION toggle
      flipPlus(pdpEl, false);                         // slide the X back down to the + spot + rotate to +
    } else if (soldout) {
      var nmOut = pdpEl.querySelector('[data-sply-name]');
      var titleOut = nmOut ? nmOut.textContent : '';
      pdpEl.classList.remove('is-buying');            // X spreads back to the + spot
      if (hlabel) scrambleTo(hlabel, titleOut);       // INFORMATION -> product title (decode)
      window.setTimeout(function () {                 // content (price / SOLD OUT) comes back right away, not after the X finishes
        setH(pdpEl, '[data-sply-price]', false);
        setH(pdpEl, '[data-sply-soldout]', false);
        setH(pdpEl, '[data-sply-info-toggle]', false);
      }, 150);
      window.setTimeout(function () {                 // heading swaps buyhead -> title once the decode lands
        setH(pdpEl, '[data-sply-buyhead]', true);
        setH(pdpEl, '[data-sply-name]', false);
        if (hlabel) hlabel.textContent = hlabel.getAttribute('data-label') || hlabel.textContent;   // reset for next open
      }, 470);
    } else {
      setH(pdpEl, '[data-sply-sizechart]', false);
      setH(pdpEl, '[data-sply-price]', false);
      setH(pdpEl, '[data-sply-sizes]', false);
      setH(pdpEl, '[data-sply-info-toggle]', false);
      if (hlabel) scrambleTo(hlabel, hlabel.getAttribute('data-label') || 'Select size');   // INFORMATION -> SELECT SIZE
    }
  }
  function addToBag(pdpEl, id) {
    if (!id) return;
    var hasSizes = !!(pdpEl && pdpEl.querySelector('[data-sply-sizes]'));
    if (pdpEl) { pdpEl.classList.remove('is-buying', 'is-collapsing'); }
    var plusBtn = pdpEl && pdpEl.querySelector('[data-sply-buy]');
    if (hasSizes) {
      setH(pdpEl, '[data-sply-name]', true);
      setH(pdpEl, '[data-sply-buyhead]', true);
      setH(pdpEl, '[data-sply-sizes]', true);
      setH(pdpEl, '[data-sply-info-toggle]', true);
      setH(pdpEl, '[data-sply-adding]', false);
    } else {
      setH(pdpEl, '[data-sply-name]', true);          // no-variant: "Adding" replaces the heading...
      setH(pdpEl, '[data-sply-adding]', false);
      if (plusBtn) plusBtn.classList.add('is-loading'); // ...and the + becomes a Dawn spinner
    }
    function restore() {
      setH(pdpEl, '[data-sply-adding]', true);
      if (hasSizes) {
        hardCollapse(pdpEl);
      } else {
        setH(pdpEl, '[data-sply-name]', false);
        if (plusBtn) plusBtn.classList.remove('is-loading');
      }
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    }).then(function (r) { return r.json().then(function (data) { return { ok: r.ok, status: r.status, data: data }; }, function () { return { ok: r.ok, status: r.status, data: null }; }); })
      .then(function (res) {
        if (res.ok) { restore(); openDrawer(true); return; }
        // add failed (e.g. sold out / unavailable variant) — surface WHY instead of silently stopping
        try { console.warn('[SPLY] add to cart failed:', res.status, res.data); } catch (e) {}
        var msg = (res.data && (res.data.description || res.data.message)) || 'Unavailable';
        var addingEl = pdpEl && pdpEl.querySelector('[data-sply-adding]');
        if (plusBtn) plusBtn.classList.remove('is-loading');
        if (addingEl) { addingEl.textContent = msg; addingEl.classList.add('is-error'); }
        window.setTimeout(function () {
          if (addingEl) { addingEl.classList.remove('is-error'); addingEl.textContent = 'Adding'; }
          restore();
        }, 2000);
      })
      .catch(function () { restore(); });
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-sply-cart-open]');
    if (open) { e.preventDefault(); if (drawer.hidden) openDrawer(); else closeDrawer(); return; }
    var close = e.target.closest('[data-sply-cart-close]');
    if (close) { e.preventDefault(); closeDrawer(); return; }

    var upToggle = e.target.closest('[data-sply-upsell-toggle]');
    if (upToggle) {
      var nowCollapsed = !upsellEl.classList.contains('is-collapsed');
      upsellEl.classList.toggle('is-collapsed', nowCollapsed);
      upToggle.setAttribute('aria-expanded', nowCollapsed ? 'false' : 'true');
      try { localStorage.setItem(UPSELL_KEY, nowCollapsed ? '1' : '0'); } catch (e) {}
      return;
    }

    var upAdd = e.target.closest('[data-sply-upsell-add]');
    if (upAdd) {
      e.preventDefault();
      var uvid = upAdd.getAttribute('data-sply-upsell-add');
      if (!uvid || uvid === '0') return;
      upAdd.classList.add('is-loading'); syncStart();
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ items: [{ id: Number(uvid), quantity: 1 }] }) })
        .then(function (r) { return r.json(); }).then(function () { refresh(); }).catch(function () { upAdd.classList.remove('is-loading'); }).then(syncEnd);
      return;
    }

    var buy = e.target.closest('[data-sply-buy]');
    if (buy) {
      e.preventDefault();
      var form0 = buy.closest('form');
      var pdp0 = buy.closest('[data-sply-pdp]');
      if (pdp0.classList.contains('sply-pdp--simple') && pdp0.classList.contains('is-info')) { exitInfo(pdp0); return; }
      if (form0 && form0.querySelector('[data-sply-sizes]')) { expandBuy(pdp0); }
      else { var h0 = form0 && form0.querySelector('[data-sply-variant-id]'); addToBag(pdp0, h0 && h0.value); }
      return;
    }
    var bclose = e.target.closest('[data-sply-buy-close]');
    if (bclose) {
      e.preventDefault();
      var pdpX = bclose.closest('[data-sply-pdp]');
      if (pdpX && pdpX.classList.contains('is-info')) exitInfo(pdpX);   // close info -> back to size select
      else collapseBuy(pdpX);                                          // close panel
      return;
    }
    var infoT = e.target.closest('[data-sply-info-toggle]');
    if (infoT) { e.preventDefault(); enterInfo(infoT.closest('[data-sply-pdp]')); return; }
    var scOpen = e.target.closest('[data-sply-sizechart]');
    if (scOpen) { e.preventDefault(); var mo = scOpen.closest('[data-sply-pdp]').querySelector('[data-sply-sizechart-modal]'); if (mo) { mo.classList.remove('is-closing'); mo.hidden = false; } return; }
    var scClose = e.target.closest('[data-sply-sizechart-close]');
    if (scClose) { e.preventDefault(); closeSizechart(scClose.closest('[data-sply-pdp]').querySelector('[data-sply-sizechart-modal]')); return; }

    var size = e.target.closest('.sply-size');
    if (size) {
      if (size.getAttribute('data-available') === 'false') return;
      var form = size.closest('form');
      var hid = form && form.querySelector('[data-sply-variant-id]');
      var vid = size.getAttribute('data-variant-id');
      if (hid && vid) hid.value = vid;
      addToBag(size.closest('[data-sply-pdp]'), vid);
      return;
    }

    var step = e.target.closest('[data-sply-qty]');
    if (step) {
      var li = step.closest('[data-key]');
      if (li) stepQty(step.getAttribute('data-sply-qty'), li, parseInt(step.getAttribute('data-delta'), 10));
      return;
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.querySelector || !form.querySelector('[data-sply-add]')) return;
    e.preventDefault();
    var hid = form.querySelector('[data-sply-variant-id]');
    addVariant(hid && hid.value, form.querySelector('[data-sply-add]'));
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var openModal = document.querySelector('[data-sply-sizechart-modal]:not([hidden])');
    if (openModal) { closeSizechart(openModal); return; }
    if (!drawer.hidden) closeDrawer();
  });

  // Reserve the buy panel for its tallest state (sizes vs description) so toggling Information
  // swaps content in place with zero page shift, and cap the description to the space left on
  // screen so it never clips (it scrolls instead). Measured synchronously (no flash).
  function reserveBuyPanel() {
    var pdp = document.querySelector('[data-sply-pdp]');
    if (!pdp) return;
    var wrap = pdp.querySelector('.sply-pdp__buy');
    var desc = pdp.querySelector('[data-sply-desc]');
    if (!wrap || !desc) return;
    // The panel height is a fixed constant (CSS min-height), so every product + every state lines up.
    // Only job here: cap the description so the info state never grows past that constant.
    var cs = getComputedStyle(wrap);
    var minH = parseFloat(cs.minHeight) || 132;
    var padTop = parseFloat(cs.paddingTop) || 22;
    desc.style.maxHeight = Math.max(64, Math.round(minH - padTop - 12)) + 'px';
  }
  reserveBuyPanel();
  document.addEventListener('sply:reserve', reserveBuyPanel);
  var rbpT = null;
  window.addEventListener('resize', function () { window.clearTimeout(rbpT); rbpT = window.setTimeout(reserveBuyPanel, 200); });

})();

